import distributors from "./components/distributor/reducer";
import units from "./components/product_unit/reducer";
import categories from "./components/product_category/reducer";
import brands from "./components/product_brand/reducer";
import products from "./components/product/reducer";

const product = { distributors, units, categories, brands, products };

export { product };
